import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ThemeProvider from "../theme/TemaMuiProvider";
import { Box, Paper, Typography, Grid, CircularProgress, Snackbar, Alert, IconButton, Tooltip } from "@mui/material";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import DescriptionIcon from "@mui/icons-material/Description";
import RefreshIcon from "@mui/icons-material/Refresh";
import { jwtDecode } from "jwt-decode";
import muiTheme from "../theme/muiTheme";

const CARDS_PROPOSTAS_SUAS_ACOES = [
  {
    chave: "aAprovar",
    titulo: "A Aprovar",
    descricao: "Propostas aguardando sua aprovação agora",
    cor: "#1998a8",
    icone: PendingActionsIcon,
    destino: { statusAprovacao: "Aprovar" },
  },
  {
    chave: "aResponder",
    titulo: "A Responder",
    descricao: "Propostas com pergunta pendente de resposta",
    cor: "#7b1fa2",
    icone: QuestionAnswerIcon,
    destino: { statusAprovacao: "Responder" },
  },
  {
    chave: "aguardandoAprovacao",
    titulo: "Aguardando Aprovação",
    descricao: "Aguardando aprovação de outro usuário no fluxo",
    cor: "#f59e0b",
    icone: HourglassEmptyIcon,
    destino: { statusAprovacao: "Aguardando" },
  },
  {
    chave: "minhasPropostas",
    titulo: "Cadastrados",
    descricao: "Total de propostas comerciais criadas por você",
    cor: "#2e7d32",
    icone: DescriptionIcon,
    destino: { minhasPropostas: "true" },
  },
];

const CARDS_PROPOSTAS_VISAO_GERAL = [
  {
    chave: "aAprovarGeral",
    titulo: "A Aprovar",
    descricao: "Propostas aguardando aprovação de qualquer usuário",
    cor: "#1998a8",
    icone: PendingActionsIcon,
    destino: { statusAprovacao: "Aprovar", escopo: "geral" },
  },
  {
    chave: "aResponderGeral",
    titulo: "A Responder",
    descricao: "Propostas com pergunta pendente de resposta",
    cor: "#7b1fa2",
    icone: QuestionAnswerIcon,
    destino: { statusAprovacao: "Responder", escopo: "geral" },
  },
  {
    chave: "aguardandoAprovacaoGeral",
    titulo: "Aguardando Aprovação",
    descricao: "Aguardando aprovação de algum usuário no fluxo",
    cor: "#f59e0b",
    icone: HourglassEmptyIcon,
    destino: { statusAprovacao: "Aguardando", escopo: "geral" },
  },
  {
    chave: "totalPropostas",
    titulo: "Cadastrados",
    descricao: "Total de propostas comerciais da empresa",
    cor: "#2e7d32",
    icone: DescriptionIcon,
    destino: {},
  },
];

const CARDS_CONTRATOS_SUAS_ACOES = [
  {
    chave: "aAprovar",
    titulo: "A Aprovar",
    descricao: "Contratos aguardando sua aprovação agora",
    cor: "#1998a8",
    icone: PendingActionsIcon,
    destino: { pendenciaAprovacao: "Aprovar" },
  },
  {
    chave: "aResponder",
    titulo: "A Responder",
    descricao: "Contratos com pergunta pendente de resposta",
    cor: "#7b1fa2",
    icone: QuestionAnswerIcon,
    destino: { pendenciaAprovacao: "Responder" },
  },
  {
    chave: "aguardandoAprovacao",
    titulo: "Aguardando Aprovação",
    descricao: "Aguardando aprovação de outro usuário no fluxo",
    cor: "#f59e0b",
    icone: HourglassEmptyIcon,
    destino: { pendenciaAprovacao: "Aguardando" },
  },
  {
    chave: "meusContratos",
    titulo: "Cadastrados",
    descricao: "Total de contratos criados por você",
    cor: "#2e7d32",
    icone: DescriptionIcon,
    destino: { meusContratos: "true" },
  },
];

const CARDS_CONTRATOS_VISAO_GERAL = [
  {
    chave: "aAprovarGeral",
    titulo: "A Aprovar",
    descricao: "Contratos aguardando aprovação de qualquer usuário",
    cor: "#1998a8",
    icone: PendingActionsIcon,
    destino: { pendenciaAprovacao: "Aprovar", escopo: "geral" },
  },
  {
    chave: "aResponderGeral",
    titulo: "A Responder",
    descricao: "Contratos com pergunta pendente de resposta",
    cor: "#7b1fa2",
    icone: QuestionAnswerIcon,
    destino: { pendenciaAprovacao: "Responder", escopo: "geral" },
  },
  {
    chave: "aguardandoAprovacaoGeral",
    titulo: "Aguardando Aprovação",
    descricao: "Aguardando aprovação de algum usuário no fluxo",
    cor: "#f59e0b",
    icone: HourglassEmptyIcon,
    destino: { pendenciaAprovacao: "Aguardando", escopo: "geral" },
  },
  { chave: "totalContratos", titulo: "Cadastrados", descricao: "Total de contratos da empresa", cor: "#2e7d32", icone: DescriptionIcon, destino: {} },
];

const CARDS_FICHAS_SUAS_ACOES = [
  {
    chave: "aAprovar",
    titulo: "A Aprovar",
    descricao: "Fichas de cadastro aguardando sua aprovação agora",
    cor: "#1998a8",
    icone: PendingActionsIcon,
    destino: { statusAprovacao: "Aprovar", processo: "Fichas" },
  },
  {
    chave: "aResponder",
    titulo: "A Responder",
    descricao: "Fichas com pergunta pendente de resposta",
    cor: "#7b1fa2",
    icone: QuestionAnswerIcon,
    destino: { statusAprovacao: "Responder", processo: "Fichas" },
  },
  {
    chave: "aguardandoAprovacao",
    titulo: "Aguardando Aprovação",
    descricao: "Aguardando aprovação de outro usuário no fluxo",
    cor: "#f59e0b",
    icone: HourglassEmptyIcon,
    destino: { statusAprovacao: "Aguardando", processo: "Fichas" },
  },
  {
    chave: "minhasFichas",
    titulo: "Cadastrados",
    descricao: "Total de fichas cadastradas em suas propostas",
    cor: "#2e7d32",
    icone: DescriptionIcon,
    destino: { minhasPropostas: "true", comFichas: "true" },
  },
];

const CARDS_FICHAS_VISAO_GERAL = [
  {
    chave: "aAprovarGeral",
    titulo: "A Aprovar",
    descricao: "Fichas aguardando aprovação de qualquer usuário",
    cor: "#1998a8",
    icone: PendingActionsIcon,
    destino: { statusAprovacao: "Aprovar", processo: "Fichas", escopo: "geral" },
  },
  {
    chave: "aResponderGeral",
    titulo: "A Responder",
    descricao: "Fichas com pergunta pendente de resposta",
    cor: "#7b1fa2",
    icone: QuestionAnswerIcon,
    destino: { statusAprovacao: "Responder", processo: "Fichas", escopo: "geral" },
  },
  {
    chave: "aguardandoAprovacaoGeral",
    titulo: "Aguardando Aprovação",
    descricao: "Aguardando aprovação de algum usuário no fluxo",
    cor: "#f59e0b",
    icone: HourglassEmptyIcon,
    destino: { statusAprovacao: "Aguardando", processo: "Fichas", escopo: "geral" },
  },
  {
    chave: "totalFichas",
    titulo: "Cadastrados",
    descricao: "Total de fichas cadastradas na empresa",
    cor: "#2e7d32",
    icone: DescriptionIcon,
    destino: { comFichas: "true" },
  },
];

const CARDS_ANALISE_CREDITO_SUAS_ACOES = [
  {
    chave: "aAprovar",
    titulo: "A Aprovar",
    descricao: "Análises de crédito aguardando sua aprovação agora",
    cor: "#1998a8",
    icone: PendingActionsIcon,
    destino: { statusAprovacao: "Aprovar", processo: "AnaliseCredito" },
  },
  {
    chave: "aResponder",
    titulo: "A Responder",
    descricao: "Análises com pergunta pendente de resposta",
    cor: "#7b1fa2",
    icone: QuestionAnswerIcon,
    destino: { statusAprovacao: "Responder", processo: "AnaliseCredito" },
  },
  {
    chave: "aguardandoAprovacao",
    titulo: "Aguardando Aprovação",
    descricao: "Aguardando aprovação de outro usuário no fluxo",
    cor: "#f59e0b",
    icone: HourglassEmptyIcon,
    destino: { statusAprovacao: "Aguardando", processo: "AnaliseCredito" },
  },
  {
    chave: "minhasAnalises",
    titulo: "Cadastrados",
    descricao: "Total de análises de crédito em suas propostas",
    cor: "#2e7d32",
    icone: DescriptionIcon,
    destino: { minhasPropostas: "true", comAnaliseCredito: "true" },
  },
];

const CARDS_ANALISE_CREDITO_VISAO_GERAL = [
  {
    chave: "aAprovarGeral",
    titulo: "A Aprovar",
    descricao: "Análises aguardando aprovação de qualquer usuário",
    cor: "#1998a8",
    icone: PendingActionsIcon,
    destino: { statusAprovacao: "Aprovar", processo: "AnaliseCredito", escopo: "geral" },
  },
  {
    chave: "aResponderGeral",
    titulo: "A Responder",
    descricao: "Análises com pergunta pendente de resposta",
    cor: "#7b1fa2",
    icone: QuestionAnswerIcon,
    destino: { statusAprovacao: "Responder", processo: "AnaliseCredito", escopo: "geral" },
  },
  {
    chave: "aguardandoAprovacaoGeral",
    titulo: "Aguardando Aprovação",
    descricao: "Análises aguardando aprovação de algum usuário no fluxo",
    cor: "#f59e0b",
    icone: HourglassEmptyIcon,
    destino: { statusAprovacao: "Aguardando", processo: "AnaliseCredito", escopo: "geral" },
  },
  {
    chave: "totalAnalises",
    titulo: "Cadastrados",
    descricao: "Total de análises de crédito da empresa",
    cor: "#2e7d32",
    icone: DescriptionIcon,
    destino: { comAnaliseCredito: "true" },
  },
];

function formatarHora(data) {
  return data.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
}

export default function DashboardContratos() {
  const navigate = useNavigate();
  const [resumoPropostas, setResumoPropostas] = useState(null);
  const [resumoContratos, setResumoContratos] = useState(null);
  const [resumoFichas, setResumoFichas] = useState(null);
  const [resumoAnaliseCredito, setResumoAnaliseCredito] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [atualizadoEm, setAtualizadoEm] = useState(null);
  const [snack, setSnack] = useState({ aberto: false, msg: "", severity: "error" });

  const token = localStorage.getItem("token");
  let tipoUsuario = "";
  if (token) {
    try {
      const decoded = jwtDecode(token);
      tipoUsuario = decoded.tipo?.toString().trim().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
    } catch (_) {}
  }
  const podeVisualizar = ["visitante", "usuario padrao", "gestor", "administrador"].includes(tipoUsuario);

  const carregarResumo = useCallback(() => {
    const tk = localStorage.getItem("token");
    setCarregando(true);
    Promise.all([
      fetch("/api/dashboard/propostas", { headers: { Authorization: `Bearer ${tk}` } }).then((r) => {
        if (!r.ok) throw new Error();
        return r.json();
      }),
      fetch("/api/dashboard/contratos", { headers: { Authorization: `Bearer ${tk}` } }).then((r) => {
        if (!r.ok) throw new Error();
        return r.json();
      }),
      fetch("/api/dashboard/fichas", { headers: { Authorization: `Bearer ${tk}` } }).then((r) => {
        if (!r.ok) throw new Error();
        return r.json();
      }),
      fetch("/api/dashboard/analise-credito", { headers: { Authorization: `Bearer ${tk}` } }).then((r) => {
        if (!r.ok) throw new Error();
        return r.json();
      }),
    ])
      .then(([propostas, contratos, fichas, analiseCredito]) => {
        setResumoPropostas(propostas);
        setResumoContratos(contratos);
        setResumoFichas(fichas);
        setResumoAnaliseCredito(analiseCredito);
        setAtualizadoEm(new Date());
      })
      .catch(() => setSnack({ aberto: true, msg: "Erro ao carregar o dashboard.", severity: "error" }))
      .finally(() => setCarregando(false));
  }, []);

  useEffect(() => {
    if (!podeVisualizar) {
      setCarregando(false);
      return;
    }
    carregarResumo();
  }, [podeVisualizar, carregarResumo]);

  const handleClickCard = (destino, rota) => {
    const params = new URLSearchParams(destino);
    navigate(`${rota}?${params}`);
  };

  const renderCards = (cards, resumo, rota) => (
    <Grid container spacing={2.5}>
      {cards.map((cfg) => {
        const Icone = cfg.icone;
        const valor = resumo?.[cfg.chave] ?? 0;
        return (
          <Grid size={{ xs: 12, sm: 6, lg: 3 }} key={cfg.chave}>
            <Tooltip title={cfg.descricao} arrow placement="top">
              <Paper
                onClick={() => handleClickCard(cfg.destino, rota)}
                sx={{
                  p: 3,
                  height: 160,
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor: "var(--ig-f-1e1e1e)",
                  borderLeft: `4px solid ${cfg.cor}`,
                  borderRadius: 2,
                  boxShadow: "0 0 20px rgba(0,0,0,0.4)",
                  transition: "transform 0.15s, box-shadow 0.15s",
                  "&:hover": { transform: "translateY(-2px)", boxShadow: "0 0 24px rgba(0,0,0,0.6)" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "var(--ig-t-aaaaaa)",
                        fontWeight: 600,
                        mb: 1,
                        letterSpacing: 0.5,
                        lineHeight: 1.3,
                        minHeight: "2.6em",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {cfg.titulo.toUpperCase()}
                    </Typography>
                    <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 700, lineHeight: 1.1, fontSize: "1.75rem" }}>{valor}</Typography>
                  </Box>
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: "50%",
                      flexShrink: 0,
                      backgroundColor: `${cfg.cor}26`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icone sx={{ fontSize: 26, color: cfg.cor }} />
                  </Box>
                </Box>

                <Typography variant="caption" sx={{ color: cfg.cor, fontWeight: 700, mt: 1 }}>
                  Ver detalhes →
                </Typography>
              </Paper>
            </Tooltip>
          </Grid>
        );
      })}
    </Grid>
  );

  return (
    <ThemeProvider theme={muiTheme}>
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", justifyContent: "space-between", gap: 1, mb: 3 }}>
          <Box>
            <Typography variant="h5" sx={{ color: "var(--ig-t-ffffff)", fontWeight: 600 }}>
              Dashboard
            </Typography>
            <Typography variant="body2" sx={{ color: "var(--ig-t-888888)", mt: 0.5 }}>
              Acompanhe suas propostas comerciais, contratos e pendências de aprovação em um só lugar.
            </Typography>
          </Box>
          {podeVisualizar && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {atualizadoEm && !carregando && (
                <Typography variant="caption" sx={{ color: "var(--ig-t-666666)" }}>
                  Atualizado às {formatarHora(atualizadoEm)}
                </Typography>
              )}
              <Tooltip title="Atualizar">
                <span>
                  <IconButton
                    size="small"
                    onClick={carregarResumo}
                    disabled={carregando}
                    sx={{ color: "var(--ig-t-aaaaaa)", "&:hover": { color: "var(--ig-t-ffffff)" } }}
                  >
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
          )}
        </Box>

        {!podeVisualizar ? (
          <Typography sx={{ color: "var(--ig-t-aaaaaa)" }}>Você não tem permissão para visualizar este dashboard.</Typography>
        ) : carregando && !resumoPropostas ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Paper
              sx={{
                p: 3,
                mb: 4,
                backgroundColor: "var(--ig-f-161616)",
                borderRadius: 2,
                boxShadow: "0 0 20px rgba(0,0,0,0.4)",
              }}
            >
              <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 700, fontSize: "1.1rem", mb: 3 }}>Suas Ações</Typography>

              <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 600, fontSize: "0.9rem", mb: 2 }}>Propostas</Typography>
              {renderCards(CARDS_PROPOSTAS_SUAS_ACOES, resumoPropostas, "/proposta-comercial")}

              <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 600, fontSize: "0.9rem", mt: 4, mb: 2 }}>Fichas de Cadastro</Typography>
              {renderCards(CARDS_FICHAS_SUAS_ACOES, resumoFichas, "/ficha-cadastro")}

              <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 600, fontSize: "0.9rem", mt: 4, mb: 2 }}>Análise de Crédito</Typography>
              {renderCards(CARDS_ANALISE_CREDITO_SUAS_ACOES, resumoAnaliseCredito, "/ficha-cadastro")}

              <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 600, fontSize: "0.9rem", mt: 4, mb: 2 }}>Contratos</Typography>
              {renderCards(CARDS_CONTRATOS_SUAS_ACOES, resumoContratos, "/contratos")}
            </Paper>

            <Paper
              sx={{
                p: 3,
                backgroundColor: "var(--ig-f-161616)",
                borderRadius: 2,
                boxShadow: "0 0 20px rgba(0,0,0,0.4)",
              }}
            >
              <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 700, fontSize: "1.1rem", mb: 3 }}>Visão Geral</Typography>

              <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 600, fontSize: "0.9rem", mb: 2 }}>Propostas</Typography>
              {renderCards(CARDS_PROPOSTAS_VISAO_GERAL, resumoPropostas, "/proposta-comercial")}

              <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 600, fontSize: "0.9rem", mt: 4, mb: 2 }}>Fichas de Cadastro</Typography>
              {renderCards(CARDS_FICHAS_VISAO_GERAL, resumoFichas, "/ficha-cadastro")}

              <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 600, fontSize: "0.9rem", mt: 4, mb: 2 }}>Análise de Crédito</Typography>
              {renderCards(CARDS_ANALISE_CREDITO_VISAO_GERAL, resumoAnaliseCredito, "/ficha-cadastro")}

              <Typography sx={{ color: "var(--ig-t-ffffff)", fontWeight: 600, fontSize: "0.9rem", mt: 4, mb: 2 }}>Contratos</Typography>
              {renderCards(CARDS_CONTRATOS_VISAO_GERAL, resumoContratos, "/contratos")}
            </Paper>
          </>
        )}
      </Box>

      <Snackbar
        open={snack.aberto}
        autoHideDuration={3500}
        onClose={() => setSnack((s) => ({ ...s, aberto: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snack.severity} variant="filled" onClose={() => setSnack((s) => ({ ...s, aberto: false }))}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}
